import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';

import { ICreateVendorOrderFromQuoteForm } from './types';

interface IProps {
  isOpen: boolean;
  onClose: (reset: UseFormReset<ICreateVendorOrderFromQuoteForm>) => void;
  onSubmit: (
    reset: UseFormReset<ICreateVendorOrderFromQuoteForm>
  ) => (data: ICreateVendorOrderFromQuoteForm) => void;
}

export const CreateVendorOrderFromQuoteFormFields = ({ isOpen, onClose, onSubmit }: IProps) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  return (
    <Form
      title={t('titleCreateOrder')}
      subtitle={t('messageConfirmOrder')}
      isOpen={isOpen}
      onSubmit={onSubmit}
      onClose={onClose}
      cancelBtnLabel={t('buttonLabelCancel')}
      disabledSubmit={!watch('agreeTermsAndConditions')}
    >
      <FormField
        name="agreeTermsAndConditions"
        type={InputType.CHECKBOX}
        inputProps={{ label: t('labelAgreeTermsAndConditions') }}
      />
    </Form>
  );
};
